import { useStore } from '../providers/store'
import { reduceCookiesByStore } from '../utils/cookies'
import { useCallback, useContext } from 'react'
import CookiesContext from 'react-cookie/es6/CookiesContext'

export const useCookiesByStoreGet = () => {
	const { code: storeCode } = useStore()
	const cookiesContextValue = useContext(CookiesContext)

	return useCallback(() => {
		const allCookies = cookiesContextValue.getAll()

		return reduceCookiesByStore(allCookies, storeCode)
	}, [cookiesContextValue, storeCode])
}
